<template>
  <div ref="container">
    <a-modal :title="title" :width="600" :visible="visible" :confirmLoading="confirmLoading" :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height: 50%;">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          关闭
        </a-button>
        <a-button type="primary" @click="handleOk">
          确认
        </a-button>
      </template>
      <a-spin :spinning="confirmLoading">
        <a-form-model ref="form" :model="form" :rules="rules">
          <a-row class="form-row" :gutter="24">
            <a-col :span="24/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="注册/备案人名称" prop="registerName">
                <a-input placeholder="请输入注册/备案人名称" v-model="form.registerName" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="注册/备案编码" prop="registerNo">
                <a-input placeholder="请输入注册/备案编码" v-model="form.registerNo" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="注册证">
                <j-image-upload v-model="fileList" bizPath="material" text="上传" isMultiple></j-image-upload>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import JImageUpload from '@/components/jeecg/JImageUpload'
import pick from 'lodash.pick'
import { certificateDetail, updateCertificate, createCertificate } from '@/api/api'
import { autoJumpNextInput } from '@/utils/util'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
export default {
  name: 'VendorModal',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    JImageUpload,
  },
  data() {
    return {
      title: '操作',
      visible: false,
      fileList: [],
      model: {},
      isReadOnly: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
      confirmLoading: false,
      form: {
        registerName: '',
        registerNo: '',
        registerImage: '',
      },
      uploadHeaders: {},
      action: window._CONFIG['domianURL'] + '/systemConfig/upload',
      rules: {
        registerName: [{ required: true, message: '注册/备案人名称不可为空!' }],
        registerNo: [{ required: true, message: '注册/备案编码不可为空!' }],
        registerImage: [{ required: true, message: '注册证不可为空!' }],
      },
      id: '',
    }
  },
  created() {},
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      if (this.$refs.form !== undefined) this.$refs.form.resetFields()
      console.log(this.form, 'form')
      console.log(this.fileList, '数组')
      if (record.id) {
        this.getInfo(record.id)
        this.id = record.id
      } else {
        this.fileList = []
      }
      this.visible = true
      this.$nextTick(() => {})
    },
    async getInfo(id) {
      this.confirmLoading = true
      const res = await certificateDetail({ id })
      console.log(res, 'res---')
      if (res.errno == 200 && res.errmsg == '成功') {
        this.form = res.data
        if (res.data.registerImage) {
          this.fileList = res.data.registerImage
        }
        this.confirmLoading = false
      } else {
        this.$message.error(res.data || res.errmsg)
        this.confirmLoading = false
      }
    },
    handleChange({ file, fileList }) {
      console.log(file, 'file')
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      // 触发表单验证
      that.$refs['form'].validate(async (success) => {
        if (success === true) {
          console.log(this.form, 'form---')
          console.log(this.fileList, '图片数组')
          if (this.fileList.length == 0) return this.$message.warning('请上传至少一张图片')
          let params = {
            registerName: this.form.registerName || '',
            registerNo: this.form.registerNo || '',
            registerImage: this.fileList || '',
          }
          if (this.id) {
            // 编辑
            params.id = this.id
            const res = await updateCertificate(params)
            console.log(res, 'res')
            if (res.errno == 200 && res.errmsg == '成功') {
              this.$message.success('添加成功')
              this.close()
            } else {
              this.$message.error(res.data || res.errmsg)
            }
          } else {
            const res = await createCertificate(params)
            console.log(res, 'res')
            if (res.errno == 200 && res.errmsg == '成功') {
              this.$message.success('更新成功')
              this.close()
            } else {
              this.$message.error(res.data || res.errmsg)
            }
          }
        }
      })
    },
    handleCancel() {
      this.close()
    },
    validateSupplierName(rule, value, callback) {
      let params = {
        name: value,
        type: '供应商',
        id: this.model.id ? this.model.id : 0,
      }
      checkSupplier(params).then((res) => {
        if (res && res.code === 200) {
          if (!res.data.status) {
            callback()
          } else {
            callback('名称已经存在')
          }
        } else {
          callback(res.data)
        }
      })
    },
  },
}
</script>
<style scoped>
</style>